import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

/*
  CR U11 — "Ad-Leads" management tool.
  Every mobile number a visitor enters on the site (to reveal a business's
  contact info from the Listings page, or via the Navbar capture) lands in
  leads_master. This screen lists them and lets an admin tag each into an
  Ad Segment for follow-up.
*/
export default function AdminAdLeads() {
    const [leads, setLeads] = useState([]);
    const [segments, setSegments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("all");

    const load = () => {
        setLoading(true);
        const q = filter === "all" ? "" : `?segment_id=${encodeURIComponent(filter)}`;
        Promise.all([
            adminFetch(`${API_BASE}/api/get_ad_leads.php${q}`).then((r) => r.json()),
            adminFetch(`${API_BASE}/api/get_ad_segments.php`).then((r) => r.json()),
        ]).then(([leadsRes, segRes]) => {
            if (leadsRes.success) setLeads(leadsRes.leads);
            if (segRes.success) setSegments(segRes.segments);
        }).finally(() => setLoading(false));
    };

    useEffect(load, [filter]);

    const assignSegment = async (leadId, segmentId) => {
        // optimistic update
        setLeads((prev) => prev.map((l) => (l.id === leadId
            ? { ...l, segment_id: segmentId || null, segment_name: segments.find((s) => String(s.id) === String(segmentId))?.name || null }
            : l)));
        await adminFetch(`${API_BASE}/api/save_lead_segment.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ lead_id: leadId, segment_id: segmentId || null }),
        });
    };

    return (
        <div>
            <h5 className="fw-bold mb-1">Ad-Leads</h5>
            <p className="text-secondary small mb-3">
                Mobile numbers captured from the site (contact-reveal prompts, navbar) — tag them into an Ad Segment for follow-up.
            </p>

            <div className="d-flex align-items-center gap-2 mb-3">
                <label className="form-label small mb-0">Filter:</label>
                <select className="form-select form-select-sm w-auto" value={filter} onChange={(e) => setFilter(e.target.value)}>
                    <option value="all">All leads</option>
                    <option value="none">Unsegmented</option>
                    {segments.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
            </div>

            <div className="card shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : leads.length === 0 ? (
                        <div className="p-3 text-secondary">No leads match this filter.</div>
                    ) : (
                        <table className="table table-sm mb-0">
                            <thead className="table-light">
                                <tr><th>Mobile</th><th>Source</th><th>Status</th><th>Events</th><th>Captured</th><th>Segment</th></tr>
                            </thead>
                            <tbody>
                                {leads.map((l) => (
                                    <tr key={l.id}>
                                        <td className="fw-semibold">{l.country_code} {l.mobile}</td>
                                        <td><span className="badge bg-secondary">{l.source}</span></td>
                                        <td>{l.status}</td>
                                        <td>{l.event_count}</td>
                                        <td className="text-secondary small">{l.created_at}</td>
                                        <td>
                                            <select
                                                className="form-select form-select-sm"
                                                value={l.segment_id || ""}
                                                onChange={(e) => assignSegment(l.id, e.target.value)}
                                            >
                                                <option value="">— none —</option>
                                                {segments.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
